import { createActions } from "@thewebops/admin-panel";

const actions = {
  publishAllProducts: createActions("company/publishAllProducts"),
  downloadImportTemplate: createActions(`company/downloadImportTemplate`),
  exportCompanies: createActions("company/exportCompanies"),
};

export default actions;
